import * as type from '../mutation-types'
const R = require('ramda')

export const teamStore = {
  namespaced: true,
  state: {
    /* API URLS */
    apiUrls: {
      step2: 'team/saveNameAndLogo',
      saveTeamname: 'team/saveTeamName',
      loadTeam: 'team/index',
      saveTraining: 'team/training/save',
      saveTrainingslager: 'team/saveTrainingslager',
      loadTraining: 'team/training/load',
      saveAufstellung: 'team/saveAufstellung',
      loadAufstellung: 'team/loadAufstellung',
      deletePlayer: 'player/delete',
      extendPlayerContract: 'player/extendContract',
      createNewPlayers: 'player/createSomePlayers',
      addNewPlayer: 'player/addPlayer',
      deleteTeamLogo: 'team/deleteTeamLogo',
      saveTeamLogo: 'team/saveTeamLogo'
    },
    imageURL: '/static/game/trainingslager/',
    team: {
      name: '',
      logo: '',
      liga: '',
      ligaId: 0,
      wurfzahl: 120
    },
    bestleistungen: {
      saison: {},
      lifetime: {}
    },
    playerBuyMultiplikator: 11,
    createdNewPlayersCounter: 0,
    createdNewPlayers: [],
    players: { },
    training: {},
    trainingsLagers: {},
    selectedTrainingslager: false,
    aufstellung: [],
    cacheTime: 0 // in sec
  },
  mutations: {
    [type.TEAM_RESET] (state) {
      state.team = {
        name: '',
        logo: '',
        liga: '',
        ligaId: 0,
        wurfzahl: 120
      }
      state.createdNewPlayersCounter = 0
      state.createdNewPlayers = []
      state.players = {}
      state.training = {}
      state.trainingsLagers = {}
      state.selectedTrainingslager = {}
      state.aufstellung = []
      state.cacheTime = 0
    },
    [type.TEAM_SET_TEAM_NAME] (state, name) {
      state.team.name = name
    },
    [type.TEAM_SET_TEAM_LOGO] (state, logo) {
      state.team.logo = logo
    },
    [type.TEAM_SET_LIGA] (state, ligaData) {
      let liga = ligaData.name
      if (ligaData.name !== '1. Bundesliga') {
        liga = ligaData.name + ' - Staffel: ' + ligaData.staffel
      }
      state.team.liga = liga
      state.team.ligaId = ligaData.id
    },
    [type.TEAM_SET_WURFZAHL] (state, wurfzahl) {
      state.team.wurfzahl = wurfzahl
    },
    [type.TEAM_SET_PLAYERS] (state, playersData) {
      state.players = playersData
    },
    [type.TEAM_SET_AUFSTELLUNG] (state, aufstellung) {
      // check if aufstellung is empty
      if (!R.isEmpty(aufstellung)) {
        // copys all the data from playerslist to aufstellungslist
        const clonePlayerData = item => {
          // get only the id
          const id = R.prop('id', item)
          // find the id in the player list
          return R.find(R.propEq('id', id))(state.players)
        }
        // set aufstellung
        state.aufstellung = R.map(clonePlayerData, aufstellung)
      }
    },
    [type.TEAM_SET_TRAINING] (state, trainingsData) {
      state.training = trainingsData.training
      if (!R.isNil(trainingsData.trainingslager) && !R.isEmpty(trainingsData.trainingslager)) {
        state.selectedTrainingslager = trainingsData.trainingslager
      }
    },
    [type.TEAM_SET_TRAININGSLAGER] (state, trainingslager) {
      if (!R.isNil(trainingslager) && !R.isEmpty(trainingslager)) {
        state.selectedTrainingslager = trainingslager
      }
    },
    [type.TEAM_SET_TRAININGSLAGERS] (state, list) {
      state.trainingsLagers = list
    },
    [type.TEAM_SET_CREATED_NEW_PLAYERS] (state, players) {
      state.createdNewPlayers = players
    },
    [type.TEAM_SET_CREATED_NEW_PLAYERS_COUNTER] (state, counter) {
      state.createdNewPlayersCounter = counter
    }
  },
  getters: {
    getLiga: (state, getters) => {
      return state.team.liga
    },
    getSallary: (state, getters) => {
      // foreach players
      // sum gehalt
      let sum = 0
      if (state.players && state.players.length > 0) {
        sum = state.players.map(item => item.gehalt).reduce((prev, next) => prev + next)
      }
      return sum
    },
    saveNameAndLogoUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.step2
    },
    loadTeamUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.loadTeam
    },
    loadTrainingUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.loadTraining
    },
    saveTeamnameUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.saveTeamname
    },
    saveTrainingUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.saveTraining
    },
    saveTrainingsLagerUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.saveTrainingslager
    },
    saveAufstellungUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.saveAufstellung
    },
    loadAufstellungUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.loadAufstellung
    },
    saveTeamLogoUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.saveTeamLogo
    },
    deleteTeamLogoUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.deleteTeamLogo
    },
    deletePlayerUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.deletePlayer
    },
    createNewPlayersUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.createNewPlayers
    },
    addNewPlayerUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.addNewPlayer
    },
    extendPlayerContractUrl: (state, getters, rootState) => {
      return rootState.apiUrls.domain + state.apiUrls.extendPlayerContract
    }
  },
  actions: {
    // extend the crontract of the player
    async extendPlayerContract ({ commit, getters, dispatch, rootState }, contractData) {
      // set transport options
      const transportOptions = {
        url: getters.extendPlayerContractUrl,
        data: contractData
      }
      // send data to server
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        // then delete from store
        commit(type.TEAM_SET_PLAYERS, response.data.teamList)
      } else {
        ret = false
      }

      return ret
    },
    // delete player from kader
    async deletePlayer ({ state, commit, getters, dispatch, rootState }, player) {
      // set transport options
      const transportOptions = {
        url: getters.deletePlayerUrl,
        data: { player: player }
      }
      // send data to server
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        // then delete from store
        commit(type.TEAM_SET_PLAYERS, response.data.teamList)
        // set new aufstellung
        commit(type.TEAM_SET_AUFSTELLUNG, response.data.aufstellung)
      } else {
        ret = false
      }

      return ret
    },
    // delete player from kader
    async deleteTeamLogo ({ state, commit, getters, dispatch }) {
      // set transport options
      const transportOptions = {
        url: getters.deleteTeamLogoUrl,
        data: { deleteLogo: true }
      }
      // send data to server
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        // then delete from store
        commit(type.TEAM_SET_TEAM_LOGO, '')
      } else {
        ret = false
      }

      return ret
    },
    // save new teamlogo to server
    async saveTeamLogo ({ commit, getters, dispatch, rootState }, payload) {
      // set transport options
      const transportOptions = {
        url: getters.saveTeamLogoUrl,
        data: payload
      }
      // send data to server
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = false
      if (response.success) {
        // set teamimage
        commit(type.TEAM_SET_TEAM_LOGO, response.data.user.teamLogo)
        // swap logo in logos
        commit('saisonStore/SAISON_SET_NEW_TEAM_LOGO', response.data.user, { root: true })
        // in saison store pt new logo for user
        commit(type.ROOT_SET_SNACKBAR, 'Logo gespeichert', { root: true })
        ret = true
      }

      return ret
    },
    // init step 2 save teamname and logo
    async saveTeamnameAndLogo ({ commit, getters, dispatch, rootState }, payload) {
      // set transport options
      const transportOptions = {
        url: getters.saveNameAndLogoUrl,
        data: payload
      }
      // send data to server
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        // set teamname
        commit(type.TEAM_SET_TEAM_NAME, response.data.name)
        // set teamimage
        commit(type.TEAM_SET_TEAM_LOGO, response.data.logo)
        // set Liga
        commit(type.TEAM_SET_LIGA, response.data.liga)
        // set players
        await commit(type.TEAM_SET_PLAYERS, response.data.players)
        commit(type.ROOT_SET_SNACKBAR, 'Dein Verein spielt ab jetzt in der ' + getters.getLiga, { root: true })
        // set fahrzeug und kegelbahn
        commit('fahrzeugStore/FAHRZEUG_SET_MY_FAHRZEUG', response.data.fahrzeug, { root: true })
        commit('kegelbahnStore/KEGELBAHN_SET_MY_KEGELBAHN', response.data.kegelbahn, { root: true })
      } else {
        ret = false
      }

      return ret
    },
    // save teamname
    async saveTeamname ({ commit, getters, dispatch, rootState }, payload) {
      // set transport options
      const transportOptions = {
        url: getters.saveTeamnameUrl,
        data: payload
      }
      // send data to server
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        // set teamname
        commit(type.TEAM_SET_TEAM_NAME, payload.teamname)
        commit(type.ROOT_SET_SNACKBAR, 'Team/Vereinsname erfolgreich gespeichert', { root: true })
      } else {
        ret = false
      }

      return ret
    },
    // load team / mannschaft with players and statistiks
    async loadTeam ({ state, commit, getters, dispatch, rootState }, sparItem) {
      // set transport options
      const transportOptions = {
        url: getters.loadTeamUrl,
        data: { loadteam: true } // set fake data
      }
      // send data to server
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (!response.success) {
        ret = false
      }

      return ret
    },
    // load Training
    async loadTraining ({ state, commit, getters, dispatch, rootState }) {
      // set transport options
      const transportOptions = {
        url: getters.loadTrainingUrl,
        data: { loadTraining: true }
      }
      // send data
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        // set trianings values
        commit(type.TEAM_SET_TRAINING, response.data)
        commit(type.TEAM_SET_TRAININGSLAGERS, response.data.trainingslagers)
      } else {
        ret = false
      }

      return ret
    },
    // save training
    async saveTraining ({ state, commit, getters, dispatch, rootState }, trainingsValues) {
      // set transport options
      const transportOptions = {
        url: getters.saveTrainingUrl,
        data: trainingsValues
      }
      // send data
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        // set trainings data
        commit(type.TEAM_SET_TRAINING, trainingsValues)
        // show save true
        commit(type.ROOT_SET_SNACKBAR, 'Training wurde erfolgreich gespeichert', { root: true })
      } else {
        ret = false
      }

      return ret
    },
    // save the trainingslager
    async saveTrainingslager ({ state, commit, getters, dispatch, rootState }, trainingslagerId) {
      // set transport options
      const transportOptions = {
        url: getters.saveTrainingsLagerUrl,
        data: {
          trainingslagerId: trainingslagerId
        }
      }
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        // set trainingslager
        commit(type.TEAM_SET_TRAININGSLAGER, response.data.trainingslager)
        // set new money
        commit('moneyStore/MONEY_SET_GIRO', response.data.giro, { root: true })
        // show save true
        commit(type.ROOT_SET_SNACKBAR, 'Trainingslager wurde erfolgreich gespeichert', { root: true })
      } else {
        ret = false
      }

      return ret
    },
    // save the current aufstellung
    async saveAufstellung ({ state, commit, getters, dispatch, rootState }, aufstellung) {
      const transportOptions = {
        url: getters.saveAufstellungUrl,
        data: {
          aufstellung: aufstellung
        }
      }
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        // save aufstellung to state
        commit(type.ROOT_SET_SNACKBAR, 'Aufstellung erfolgreich gespeichert', { root: true })
      } else {
        ret = false
      }

      return ret
    },
    // load Training
    async loadAufstellung ({ state, commit, getters, dispatch, rootState }) {
      // set transport options
      const transportOptions = {
        url: getters.loadAufstellungUrl,
        data: { loadAufstellung: true }
      }
      // send data
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        // set aufstellungslist
        commit(type.TEAM_SET_AUFSTELLUNG, response.data.aufstellung)
      } else {
        ret = false
      }

      return ret
    },
    // create some new players
    async createNewPlayers ({ state, commit, getters, dispatch, rootState }, age) {
      // set transport options
      const transportOptions = {
        url: getters.createNewPlayersUrl,
        data: { age: age }
      }
      // send data
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        // set aufstellungslist
        commit(type.TEAM_SET_CREATED_NEW_PLAYERS, response.data.newPlayers)
        commit(type.TEAM_SET_CREATED_NEW_PLAYERS_COUNTER, response.data.counter)
      } else {
        ret = false
      }

      return ret
    },

    // add one new player to the team
    async addNewPlayer ({ state, commit, getters, dispatch, rootState }, player) {
      // set transport options
      const transportOptions = {
        url: getters.addNewPlayerUrl,
        data: { player: player }
      }
      // send data
      const response = await dispatch('sendDataToServer', transportOptions, { root: true })

      let ret = true
      if (response.success) {
        // setze new giro
        commit('moneyStore/MONEY_SET_GIRO', response.data.giro, { root: true })
        // setze created player
        commit(type.TEAM_SET_CREATED_NEW_PLAYERS, response.data.newPlayers)
        // setze new team
        commit(type.TEAM_SET_PLAYERS, response.data.teamList)
      } else {
        ret = false
      }

      return ret
    }

  }
}
